import { TodoDatePeriod } from "../types";

interface EmptyStateMessage {
  title: string;
  description?: string;
}

/**
 * Get an appropriate empty state message based on the current filter
 */
export function getEmptyStateMessage(filter: TodoDatePeriod): EmptyStateMessage {
  const messages: Record<TodoDatePeriod, EmptyStateMessage> = {
    today: {
      title: "No todos for today",
      description: "You're all caught up! Add a new todo or check another day.",
    },
    tomorrow: {
      title: "No todos for tomorrow",
      description: "Great! You have a clear schedule. Plan ahead if needed.",
    },
    week: {
      title: "No todos this week",
      description: "Enjoy your free week! Add todos as they come up.",
    },
    upcoming: {
      title: "No upcoming todos",
      description: "No tasks on the horizon. Create a new todo to get started.",
    },
    done: {
      title: "No completed todos",
      description: "You haven't finished any todos yet. Keep working!",
    },
  };

  return messages[filter] ?? messages.upcoming;
}

/**
 * Get just the title for an empty state based on the filter
 */
export function getEmptyStateTitle(filter: TodoDatePeriod): string {
  return getEmptyStateMessage(filter).title;
}

/**
 * Get just the description for an empty state based on the filter
 */
export function getEmptyStateDescription(filter: TodoDatePeriod): string | undefined {
  return getEmptyStateMessage(filter).description;
}
